(function () {
  // card-product.liquid is rendered once per card via {% render %}, which has
  // isolated Liquid scope — the Liquid guard does not prevent the script tag
  // from appearing N times (once per card). This JS guard ensures the
  // event listeners are registered only once across all those executions.
  if (window.__wishlistHeroReady) return;
  window.__wishlistHeroReady = true;

  function syncButtonStates() {
    const sdk = window.WishListHero_SDK;
    if (!sdk) return;
    const items = sdk.GetWishListItems();
    const wishlisted = new Set(items.map((i) => String(i.ProductVariantId)));
    document.querySelectorAll('.wishlist-toggle-btn').forEach((btn) => {
      btn.classList.toggle('wishlist-toggle-btn--active', wishlisted.has(String(btn.dataset.variantId)));
    });
  }

  document.addEventListener('wishlist-hero-wishlist-sdk-ready', function () {
    syncButtonStates();
    watchPopupRemovals();
  });

  // After variant change, <variant-radios> is replaced with fresh Liquid HTML.
  // The new button has correct data-variant-id but no active class — re-sync.
  document.addEventListener('afterVariantChanged', function () {
    syncButtonStates();
  });

  // Watch for the SDK's own removal notification toast.
  // The Wishlist Hero popup calls its own DeleteWishListItem internally —
  // we have no hook into that. But the SDK always renders
  // .wishlist-hero-removed-product-notification after a successful delete,
  // so we observe for that node appearing and re-sync our heart states.
  function watchPopupRemovals() {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (
            node.classList.contains('wishlist-hero-removed-product-notification') ||
            node.querySelector('.wishlist-hero-removed-product-notification')
          ) {
            syncButtonStates();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.wishlist-toggle-btn');
    if (!btn) return;
    e.preventDefault();

    const sdk = window.WishListHero_SDK;
    if (!sdk) return;

    btn.disabled = true;
    try {
      const hash = await sdk.GetWishListHash(true);

      // On product pages, read the actual selected variant from the product form —
      // it is always kept in sync by updateVariantInputs, even before afterVariantChanged fires.
      // Fall back to data-variant-id for collection cards (no data-section-id attribute).
      let variantId = parseInt(btn.dataset.variantId);
      const sectionId = btn.dataset.sectionId;
      if (sectionId) {
        const formInput = document.querySelector(`#product-form-${sectionId} input[name="id"]`);
        if (formInput) variantId = parseInt(formInput.value);
      }

      const items = sdk.GetWishListItems();
      const isWishlisted = items.some((i) => String(i.ProductVariantId) === String(variantId));

      if (isWishlisted) {
        const deleted = await sdk.DeleteWishListItem({ ProductVariantId: variantId, WishlistHash: hash });
        if (deleted) btn.classList.remove('wishlist-toggle-btn--active');
      } else {
        // Sync price from variant-prices-json if available (product page), fall back to data attribute
        let productPrice = parseInt(btn.dataset.productPrice);
        if (sectionId) {
          try {
            const pricesEl = document.getElementById('variant-prices-json');
            if (pricesEl) {
              const prices = JSON.parse(pricesEl.textContent);
              if (prices[variantId]) productPrice = prices[variantId].price;
            }
          } catch (_) {}
        }

        const productInfo = {
          ProductId: parseInt(btn.dataset.productId),
          ProductVariantId: variantId,
          ProductTitle: btn.dataset.productTitle,
          ProductPrice: productPrice / 100,
          ProductLink: btn.dataset.productLink,
          ProductImage: btn.dataset.productImage.replace(/^https?:/, ''),
          WishlistHash: hash,
        };
        const customerId = sdk.GetCustomerId();
        if (customerId) productInfo.CustomerId = parseInt(customerId);

        const added = await sdk.AddWishListItem(productInfo);
        if (added) {
          btn.classList.add('wishlist-toggle-btn--active');
          sdk.OpenWishList();
        }
      }
    } finally {
      btn.disabled = false;
    }
  });
})();
